import { render, staticRenderFns } from "./ModalResend.vue?vue&type=template&id=6091f05d&"
import script from "./ModalResend.vue?vue&type=script&lang=js&"
export * from "./ModalResend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports